<template>
  <div class="basic_wrap">
    <bsHeader
      :title="$t('utils.lunlog36')"
      @backurl="$router.back()"
    />
    
    <div class="main_content">
      <!-- 纯白卡片容器 -->
      <div class="card_box auth_wrap">
        <form class="form" @submit.prevent="submit">
          
          <!-- 1. 用户名 -->
          <div class="input_wrap">
            <input
              v-model.trim="username"
              type="text"
              class="inp"
              :placeholder="$t('login.username')"
            >
          </div>

          <!-- 2. 邮箱 -->
          <div class="input_wrap">
            <input
              v-model.trim="email"
              type="text"
              class="inp"
              :placeholder="$t('auth.emailEmpty')"
            >
          </div>

          <!-- 3. 验证码 (带右侧发送按钮) -->
          <div class="code_row">
            <div class="input_wrap code_input">
              <input
                v-model.trim="code"
                type="text"
                class="inp"
                :placeholder="$t('auth.emailCode')"
              >
            </div>
            <van-count-down
              :time="time"
              class="get_captcha_btn"
              @finish="timeCall"
            >
              <template v-slot="timeData">
                <span 
                  class="send_btn"
                  :class="{ disabled: is_send || timeData.seconds > 0 }"
                  @click="sendcode"
                >
                  {{ timeData.seconds > 0 ? timeData.seconds + 's' : $t('auth.sendEmailCode') }}
                </span>
              </template>
            </van-count-down>
          </div>

          <!-- 4. 新密码 -->
          <div class="input_wrap">
            <input
              v-model.trim="newpwd"
              type="password"
              class="inp"
              :placeholder="$t('utils.lunlog20')"
            >
          </div>

          <!-- 5. 确认密码 -->
          <div class="input_wrap">
            <input
              v-model.trim="conpwd"
              type="password"
              class="inp"
              :placeholder="$t('utils.lunlog23')"
            >
          </div>

          <!-- 6. 提交按钮 (完美复刻截图渐变蓝) -->
          <button
            type="submit"
            class="submit_btn"
            :class="email && code && newpwd && conpwd ? '' : 'disabled'"
          >
            {{ $t('utils.confirm') }}
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { CountDown, Checkbox } from "vant";
import Fetch from '../../utils/fetch';
import bsHeader from '../../components/bsHeader.vue';
Vue.use(CountDown).use(Checkbox);

export default {
  name: "Pwd",
  components: { bsHeader },
  data() {
    return {
      data: {},
      time: 0,
      email: '',
      username:'',
      pwd:'',
      code: '',
      oldpwd:'',
      newpwd:'',
      conpwd:'',
      is_send: false
    };
  },
  created() {
    if (window.plus) {
      plus.navigator.setStatusBarBackground('#FFFFFF');
      plus.navigator.setStatusBarStyle('dark');
    }
    this.$parent.footer('user', false);
  },
  mounted() {
    // 页面初始化获取数据的话可放在这里，暂时留空
  },
  methods: {
    timeCall() {
      this.is_send = false;
      this.time = 0;
    },
    sendcode() {
      if (this.is_send) return false;
      if (!this.email) {
        this.$toast(this.$t('auth.emailEmpty'));
        return false;
      }
      if (!this.username) {
        this.$toast(this.$t('login.usernameEmpty'));
        return false; 
      }
      if (this.username.length > 16 || this.username.length < 4) {
        this.$toast(this.$t('login.usernameLength'));
        return false;
      }
      var reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (!reg.test(this.email)) {
        this.$toast(this.$t('auth.emailError'));
        return false;
      }
      this.is_send = true;

      Fetch("/index/getEmailCode", {
        email: this.email,
        username: this.username
      }).then(() => {
        this.time = 60 * 1000;
        this.$toast({
          background: "#07c160",
          message: this.$t('auth.sendsuccess'),
        });
      }).catch(() => {
        this.is_send = false;
      });
    },
    submit() {
      if (!this.newpwd) {
        this.$toast(this.$t('utils.lunlog20'));
        return false;
      }
      if (!this.conpwd) {
        this.$toast(this.$t('utils.lunlog23'));
        return false;
      }
      if (this.newpwd != this.conpwd) {
        this.$toast(this.$t('utils.lunlog24'));
        return false;
      }
      
      Fetch('/index/pwd', {
        oldpwd: this.oldpwd,
        newpwd: this.newpwd,
        conpwd: this.conpwd,
        username: this.username,
        email: this.email,
        code: this.code
      }).then(r => {
        if (r.code == '218') {
          this.$toast(this.$t(r.info));
          return false;
        } else {
          this.$toast({
            background: '#07c160',
            message: this.$t('utils.lunlog37')
          });
          this.$router.replace('/user')
        }
      })
    },
  }
};
</script>

<style lang="less" scoped>
/* ================= 全局基础样式 ================= */
.basic_wrap {
  position: relative;
  overflow: hidden;
  min-height: 100vh;
  padding-bottom: 60px;
  /* 浅蓝网格纹理背景 (彻底去黑) */
  background: linear-gradient(180deg, #f8fbff, #eef4fb 42%, #f6f8fc);
}

.main_content {
  padding: 20px 16px 0;
  display: flex;
  justify-content: center;
}

/* ================= 白色表单卡片 ================= */
.card_box.auth_wrap {
  background: #ffffff;
  border-radius: 18px;
  padding: 24px 20px 30px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 4px 16px rgba(24, 61, 122, 0.06);
  border: 1px solid rgba(176, 202, 240, 0.3);
  /* 去掉多余的外边距干扰 */
  margin-top: 0;

  .form {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
}

/* ================= 输入框通用样式 (高 50px、圆角、灰底) ================= */
.input_wrap {
  width: 100%;
  height: 50px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  padding: 0 16px;
  transition: border-color 0.2s;

  &:focus-within {
    border-color: #2563eb;
  }

  .inp {
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    background: transparent;
    font-size: 14px;
    color: #1a2742;
    &::placeholder { color: #94a3b8; }
    &:read-only { color: #64748b; }
  }
}

/* ================= 验证码行 (左侧输入框 + 右侧获取按钮) ================= */
.code_row {
  display: flex;
  gap: 10px;
  align-items: stretch;

  .code_input {
    flex: 1;
  }

  .get_captcha_btn {
    display: flex;
    align-items: center;
  }

  .send_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    padding: 0 16px;
    background: #eff6ff;
    color: #2563eb;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    transition: all 0.2s;
    
    &:active { opacity: 0.8; transform: scale(0.96); }
    &.disabled {
      background: #f1f5f9;
      color: #94a3b8;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
}

/* ================= 提交按钮 (蓝青色渐变、圆角胶囊) ================= */
.submit_btn {
  width: 100%;
  height: 50px;
  border-radius: 25px;
  border: none;
  background: linear-gradient(90deg, #8cb1ff, #7ed4f0);
  color: #fff;
  font-size: 17px;
  font-weight: 700;
  cursor: pointer;
  margin-top: 12px;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);
  transition: all 0.2s;
  
  &:active { transform: scale(0.97); }
  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>